import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({setFilters, filters}) => {
    const {
        boListReason,
        boListLeader,
        boListTeam,
        boListGuard,
        boListPlaces,
        boListStreet,
        boListNeighborhood,
        boListSector
    } = useReportFiltersFetch({
        fetchBOListReason: true,
        fetchBOListLeader: true,
        fetchBOListTeam: true,
        fetchBOListGuard: true,
        fetchBOListPlaces: true,
        fetchBOListStreet: true,
        fetchBOListNeighborhood: true,
        fetchBOListSector: true
    })

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="D/H inicial do fato *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="D/H final do fato *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />

                    <SelectComponent
                        label='Natureza'
                        isMulti={true}
                        wrapValues={true}
                        options={boListReason}
                        value={filters.reason}
                        onChange={(value) => setFilters(prev => ({...prev, reason: value}))}
                        instanceId="reason"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Status'
                        isMulti={true}
                        wrapValues={true}
                        options={[
                            {label: "Numeração gerada", value: 'NUMBER_GENERATED'},
                            {label: "Em preenchimento", value: 'DRAFT'},
                            {label: "Excluído (app)", value: 'APP_DELETED'},
                            {label: "Excluído (sistema)", value: 'SYSTEM_DELETED'},
                            {label: "Documento enviado", value: 'FILE_SENT'},
                            {label: "Pendente (aprovação)", value: 'PENDING'},
                            {label: "Revisado", value: 'REVIEWED'},
                            {label: "Reprovado", value: 'REJECTED'},
                            {label: "Aprovado", value: 'APPROVED'},
                            {label: "Invalidado", value: 'INVALIDATED'},
                        ]}
                        value={filters.status}
                        onChange={(value) => setFilters(prev => ({...prev, status: value}))}
                        instanceId="status"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Flagrante'
                        isMulti={true}
                        wrapValues={true}
                        options={[
                            {label: "Sim", value: 'true'},
                            {label: "Não", value: 'false'}
                        ]}
                        value={filters.flagrant}
                        onChange={(value) => setFilters(prev => ({...prev, flagrant: value}))}
                        instanceId="flagrant"
                        classNameWrapper={"w-full"}
                        isClearable={true}
                    />

                    <SelectComponent
                        label='Responsável'
                        isMulti={true}
                        wrapValues={true}
                        options={boListLeader}
                        value={filters.leader}
                        onChange={(value) => setFilters(prev => ({...prev, leader: value}))}
                        instanceId="leader"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Equipe'
                        isMulti={true}
                        wrapValues={true}
                        options={boListTeam}
                        value={filters.team}
                        onChange={(value) => setFilters(prev => ({...prev, team: value}))}
                        instanceId="team"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Contingente'
                        isMulti={true}
                        wrapValues={true}
                        options={boListGuard}
                        value={filters.guard}
                        onChange={(value) => setFilters(prev => ({...prev, guard: value}))}
                        instanceId="guard"
                        classNameWrapper={"w-full"}
                    />

                    <InputForm
                        label="Guarnição"
                        value={filters.garrison}
                        onChange={({target}) => setFilters(prev => ({ ...prev, garrison: target.value }))}
                        instanceId="garrison"
                        id="garrison"
                        classNameWrapper={"w-full"}
                        autocomplete={'off'}
                    />

                    <SelectComponent
                        label='Local pré-cadastrado'
                        isMulti={true}
                        wrapValues={true}
                        options={boListPlaces}
                        value={filters.places}
                        onChange={(value) => setFilters(prev => ({...prev, places: value}))}
                        instanceId="places"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Logradouro'
                        isMulti={true}
                        wrapValues={true}
                        options={boListStreet}
                        value={filters.street}
                        onChange={(value) => setFilters(prev => ({...prev, street: value}))}
                        instanceId="street"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Bairro'
                        isMulti={true}
                        wrapValues={true}
                        options={boListNeighborhood}
                        value={filters.neighborhood}
                        onChange={(value) => setFilters(prev => ({...prev, neighborhood: value}))}
                        instanceId="neighborhood"
                        classNameWrapper={"w-full"}
                    />

                    <SelectComponent
                        label='Setor da guarnição'
                        isMulti={true}
                        wrapValues={true}
                        options={boListSector}
                        value={filters.sector}
                        onChange={(value) => setFilters(prev => ({...prev, sector: value}))}
                        instanceId="sector"
                        classNameWrapper={"w-full"}
                    />

                </form>
            </div>
        </>
    );
};

export default Filters;